import { type FieldError } from 'react-hook-form';
import { Button } from '@bedrock/ui/button';
import { Calendar } from '@bedrock/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@bedrock/ui/popover';
import { cn } from '@bedrock/ui/utils';
import { CalendarIcon } from 'lucide-react';

type DatePickerFieldProps = Readonly<{
  placeholder: string;
  date?: Date;
  onDateSelect: (date: Date | undefined) => void;
  error?: FieldError;
  onBlur?: () => void;
}>;

export function DatePicker({ placeholder, date, onDateSelect, onBlur }: DatePickerFieldProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          onBlur={onBlur}
          size="unset"
          variant="unset"
          className={cn(
            'br-type-functional-input inline-flex h-[var(--component-inputs-size-height)] w-full cursor-pointer items-center justify-start gap-2 rounded-[var(--component-inputs-radius)] border-0 border-solid border-[var(--component-inputs-size-border-width)] bg-[hsl(var(--component-inputs-color-background))] px-[var(--component-inputs-padding-horizontal)] text-[hsl(var(--component-inputs-color-foreground))] !outline-none !ring-offset-0 ![--tw-ring-offset-width:0px]',
            !date && 'text-[hsl(var(--component-inputs-color-placeholder))]',
          )}
        >
          <CalendarIcon aria-hidden="true" className="size-4 shrink-0" focusable="false" />
          {date ? (
            date.toLocaleString('en-GB', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })
          ) : (
            <span>{placeholder}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2">
        <Calendar mode="single" onSelect={onDateSelect} selected={date} />
      </PopoverContent>
    </Popover>
  );
}
